<template>
  <div><p>Jos ne radi - Nudim</p></div>
</template>

<script>
export default {};
</script>

<style>
</style>